import { IAppState } from '../../../AppModulesWrapper';

export function selectOfferGuid(state: IAppState): string {
  return state.servicePickerWidget.offer.objectGuid;
}
